import { Role } from '@models/Role'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { emailRule, requiredRule } from '@utils/rules'
import { Card, Flex, Form, Input } from 'antd'
import { useEffect } from 'react'
import { RoleFormItem } from './Form'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const rolesForm = Form.useWatch<RoleFormItem[]>('roles', form) || []

  useEffect(() => {
    form.setFieldsValue({
      roles: [{ role: null, entity: null, extraIds: null }],
    })
  }, [])

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="email"
        rules={[requiredRule(), emailRule()]}
        label="Email"
      >
        <Input />
      </Form.Item>

      {/* At the moment only one role can be associated to an Admin
      Even though the API can handle multiple, we keep this posibility for later if needed
      That's why you will see mutliple things commented or unsued below
      */}
      <Form.List name="roles">
        {(fields, { add, remove }) => (
          <Flex gap={16} vertical>
            {fields.map(({ key, name, ...restField }) => {
              const entity = rolesForm?.[name]?.['entity'] || null

              return (
                <Card
                  key={key}
                  title={'Role'}
                  // title={`Role ${name + 1}`}
                  // extra={<CloseOutlined onClick={() => remove(name)} />}
                  size="small"
                >
                  <Form.Item
                    {...restField}
                    label="Role"
                    name={[name, 'role']}
                    rules={[requiredRule()]}
                  >
                    <SBAsyncSelect<Role>
                      entity={Entity.role}
                      allowClear
                      overrideOptions={{
                        addExtraAttributes: (item) => ({ entity: item.entity }),
                      }}
                      onChange={(value, rawOption) => {
                        const option =
                          (Array.isArray(rawOption)
                            ? rawOption[0]
                            : rawOption) || null
                        // As we override onChange() method, we need to set role ourselves
                        form.setFieldValue(['roles', name, 'role'], value)
                        form.setFieldValue(
                          ['roles', name, 'entity'],
                          option?.entity
                        )
                      }}
                    />
                  </Form.Item>

                  <Form.Item {...restField} hidden name={[name, 'entity']}>
                    <Input hidden />
                  </Form.Item>

                  {entity && (
                    <Form.Item
                      {...restField}
                      label={'Specific access'}
                      name={[name, 'extraIds']}
                      rules={[requiredRule()]}
                    >
                      <SBAsyncSelect
                        placeholder={`Select ${entity}(s)`}
                        entity={entity}
                        multiple
                        allowClear
                      />
                    </Form.Item>
                  )}
                </Card>
              )
            })}

            {/* <Button type="dashed" onClick={() => add()} block>
              + Add role
            </Button> */}
          </Flex>
        )}
      </Form.List>
    </Form>
  )
}

export default Create
